import { TransportMode } from '../../../../../common';
import { WaybillIdView, CarriageType, Deviation, LocalDate } from '../../../../models';
import { LoadPrimary, TransportOrderPrimary } from '../../transport';
import { LatestNotification } from '../../models';
import { MonitoringStatus, WaybillIdType } from '../../../../constants';
import { ListViewMode } from '../../constants';

export interface TransportManagementTileItem {
  webContentTypeView: ListViewMode;
  content: TransportOrderPrimary | LoadPrimary | WaybillModel;
}

export interface TransportManagementTile {
  reportLimitationExceeded: boolean;
  items: TransportManagementTileItem[];
}

export interface CarriageBrief {
  actualDateTime: LocalDate;
  estimatedDateTime: LocalDate;
  carriageType: CarriageType;
  carrierId: string;
  carrierName: string;
  carrierTO: string;

  deliveryAddress: string;
  deliveryExtId: string;
  deliveryName: string;

  deviation: Deviation;
  latestNotification: LatestNotification;
  masterNumber: string;
  masterNumberType: WaybillIdType.MAWB | WaybillIdType.MBL;

  pickUpAddress: string;
  pickUpExtId: string;
  pickUpName: string;

  plannedDateTime: LocalDate;

  status: MonitoringStatus;
  statusCode: string;
  statusCodeDescription: string;
  statusLocationAddress: string;
  statusLocationExtId: string;
  statusLocationName: string;

  transportMode: TransportMode;
}

export interface WaybillModel {
  carriages: CarriageBrief[];

  consigneeAddress: string;
  consigneeExtId: string;
  consigneeName: string;

  consignorAddress: string;
  consignorExtId: string;
  consignorName: string;

  deliveryNoteNumbers: string[];
  deviation: Deviation;
  invoiceNumbers: string[];
  latestNotification: LatestNotification;

  statusCode: string;
  statusCodeDescription: string;
  statusLocationAddress: string;
  statusLocationExtId: string;
  statusLocationName: string;

  waybillIdView: WaybillIdView;
}
